export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line', description: '浏览所有韩国漫画资源' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的爱情故事' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '充满想象力的奇幻世界' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的动作冒险' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line', description: '轻松愉快的搞笑日常' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '深刻感人的剧情故事' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖漫画' },
];

export const comics = [
  {
    id: 1,
    title: '她的反击',
    slug: 'her-counterattack',
    author: '金智恩',
    category: 'romance',
    categoryName: '恋爱',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20romance%20genre%2C%20beautiful%20female%20protagonist%20with%20determined%20expression%2C%20soft%20pastel%20color%20palette%2C%20clean%20minimal%20background%2C%20digital%20illustration%20with%20smooth%20lines%2C%20Korean%20webtoon%20aesthetic&width=800&height=1100&seq=hanman-comic-01&orientation=portrait',
    description: '被前男友背叛后，她决心改变自己。从一个柔弱的女孩蜕变成独立自信的女性，在事业和爱情中开启全新的反击之路。',
    descriptionHtml: '<p>被前男友背叛后，她决心改变自己。从一个柔弱的女孩蜕变成独立自信的女性，在事业和爱情中开启全新的反击之路。</p><p>在这个过程中，她遇到了温柔体贴的总裁和一直默默守护的青梅竹马，两个男人的出现让她的生活变得更加精彩。但复仇之路并不平坦，前男友的阻挠、职场的明争暗斗，她能否一一克服？</p>',
    rating: 9.2,
    views: 1250000,
    updatedAt: '2026-08-04',
    tags: ['复仇', '职场', '三角恋', '逆袭'],
    chapters: 86,
    featured: true,
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '无限之塔',
    slug: 'infinite-tower',
    author: '朴宰贤',
    category: 'fantasy',
    categoryName: '奇幻',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20fantasy%20genre%2C%20mysterious%20tower%20reaching%20into%20the%20sky%2C%20male%20protagonist%20with%20magical%20aura%2C%20dark%20mystical%20color%20scheme%2C%20clean%20illustration%20style%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-02&orientation=portrait',
    description: '一座突然出现在城市中心的无限之塔，吸引了无数冒险者前往挑战。主角作为一个最底层的E级能力者，意外获得了塔中的神秘力量。',
    descriptionHtml: '<p>一座突然出现在城市中心的无限之塔，吸引了无数冒险者前往挑战。主角作为一个最底层的E级能力者，意外获得了塔中的神秘力量。</p><p>从此，他开始了不断向上攀登的旅程。每一层塔都是一个全新的世界，潜藏着不同的怪物、谜题和宝藏。随着层数的提高，他也逐渐揭开了塔背后隐藏的惊天秘密。</p>',
    rating: 9.5,
    views: 2300000,
    updatedAt: '2026-08-05',
    tags: ['升级', '冒险', '魔法', '怪物'],
    chapters: 124,
    featured: true,
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '暗夜追踪者',
    slug: 'night-tracker',
    author: '李东旭',
    category: 'action',
    categoryName: '动作',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20action%20genre%2C%20mysterious%20male%20character%20in%20black%20suit%20at%20night%2C%20cyberpunk%20city%20background%2C%20dark%20moody%20color%20palette%2C%20clean%20sharp%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-03&orientation=portrait',
    description: '白天是普通的上班族，夜晚则化身为追踪犯罪者的正义使者。主角的双重身份让他在危险与正义之间不断穿梭。',
    descriptionHtml: '<p>白天是普通的上班族，夜晚则化身为追踪犯罪者的正义使者。主角的双重身份让他在危险与正义之间不断穿梭。</p><p>首尔的地下世界暗流涌动，一个庞大的犯罪组织正在计划一场足以颠覆整座城市的阴谋。在追查真相的过程中，他发现这个组织竟然与自己过去的家人悲剧有着千丝万缕的联系。</p>',
    rating: 9.0,
    views: 1800000,
    updatedAt: '2026-08-03',
    tags: ['都市', '犯罪', '双重身份', '复仇'],
    chapters: 95,
    featured: true,
    isHot: false,
    isNew: false,
  },
  {
    id: 4,
    title: '第七个秘密',
    slug: 'seventh-secret',
    author: '崔美英',
    category: 'thriller',
    categoryName: '悬疑',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20thriller%20mystery%20genre%2C%20female%20detective%20looking%20suspicious%2C%20dark%20rainy%20atmosphere%2C%20cold%20blueish%20tone%2C%20clean%20dramatic%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-04&orientation=portrait',
    description: '一起看似意外的死亡事件，背后却隐藏着六个不为人知的秘密。而当第七个秘密浮出水面时，真相远比想象中更加可怕。',
    descriptionHtml: '<p>一起看似意外的死亡事件，背后却隐藏着六个不为人知的秘密。而当第七个秘密浮出水面时，真相远比想象中更加可怕。</p><p>女主角是一名新人刑警，被分配到这个看似普通的案件。随着调查的深入，她发现死者生前接触的每一个人都隐藏着不为人知的一面。每个人都是嫌疑人，每个人都有自己的秘密。</p>',
    rating: 8.8,
    views: 980000,
    updatedAt: '2026-08-02',
    tags: ['推理', '犯罪', '反转', '心理'],
    chapters: 67,
    featured: false,
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '校园爆笑日记',
    slug: 'school-comedy-diary',
    author: '宋民浩',
    category: 'comedy',
    categoryName: '喜剧',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20comedy%20genre%2C%20funny%20high%20school%20students%20with%20exaggerated%20expressions%2C%20bright%20colorful%20palette%2C%20cheerful%20vibrant%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-05&orientation=portrait',
    description: '一群高中生的爆笑日常，从课堂到食堂，从考试到约会，每一页都让你笑到停不下来。',
    descriptionHtml: '<p>一群高中生的爆笑日常，从课堂到食堂，从考试到约会，每一页都让你笑到停不下来。</p><p>主角是一个总爱搞怪的普通高中生，身边聚集了一群性格各异的朋友：学霸但社交恐惧的眼镜男、运动全能但极度花痴的体育委员、表面高冷实则逗比的转学生。他们的高中生活充满了意想不到的欢乐和感动。</p>',
    rating: 9.1,
    views: 1560000,
    updatedAt: '2026-08-05',
    tags: ['校园', '搞笑', '日常', '青春'],
    chapters: 145,
    featured: false,
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '眼泪的重量',
    slug: 'weight-of-tears',
    author: '郑瑞妍',
    category: 'drama',
    categoryName: '剧情',
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20drama%20genre%2C%20emotional%20female%20character%20looking%20down%20in%20rain%2C%20melancholic%20atmosphere%2C%20soft%20muted%20color%20tones%2C%20clean%20poetic%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-06&orientation=portrait',
    description: '一个单亲妈妈独自抚养三个孩子的感人故事，生活的艰辛和母爱的伟大交织成了一部触动人心的作品。',
    descriptionHtml: '<p>一个单亲妈妈独自抚养三个孩子的感人故事，生活的艰辛和母爱的伟大交织成了一部触动人心的作品。</p><p>丈夫意外离世后，三十三岁的尹秀雅独自撑起了整个家。大女儿正值叛逆期，二儿子有自闭症需要特殊照顾，小女儿还只有三岁。在生活的重压下，她从未放弃，用爱与坚韧守护着这个家。</p>',
    rating: 9.7,
    views: 890000,
    updatedAt: '2026-07-20',
    tags: ['家庭', '母爱', '治愈', '现实'],
    chapters: 72,
    featured: true,
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '深渊之眼',
    slug: 'abyss-eye',
    author: '韩志浩',
    category: 'horror',
    categoryName: '恐怖',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20horror%20genre%2C%20creepy%20eye%20in%20darkness%2C%20disturbing%20atmosphere%2C%20dark%20red%20and%20black%20color%20scheme%2C%20clean%20thrilling%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-07&orientation=portrait',
    description: '每当深夜降临，那扇紧闭的门后总会传来奇怪的眼睛注视着你。没有人知道门后是什么，但所有人都知道——不要打开它。',
    descriptionHtml: '<p>每当深夜降临，那扇紧闭的门后总会传来奇怪的眼睛注视着你。没有人知道门后是什么，但所有人都知道——不要打开它。</p><p>搬进这栋廉价公寓的大学生李承宇，开始经历一系列无法解释的恐怖事件。镜子里的倒影会自己移动，走廊尽头总有脚步声，而最可怕的是那扇被房东叮嘱绝对不能打开的门。</p>',
    rating: 8.6,
    views: 750000,
    updatedAt: '2026-08-01',
    tags: ['恐怖', '都市传说', '超自然', '惊悚'],
    chapters: 53,
    featured: false,
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: '魔王的契约',
    slug: 'demon-king-contract',
    author: '尹泰亨',
    category: 'fantasy',
    categoryName: '奇幻',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20fantasy%20genre%2C%20demon%20king%20with%20dark%20armor%20and%20glowing%20eyes%2C%20magical%20contract%20scroll%2C%20epic%20dark%20fantasy%20atmosphere%2C%20clean%20dramatic%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-08&orientation=portrait',
    description: '为了拯救濒死的妹妹，少年与魔王签订了契约。但他不知道的是，这份契约的代价远比他想象的更加沉重。',
    descriptionHtml: '<p>为了拯救濒死的妹妹，少年与魔王签订了契约。但他不知道的是，这份契约的代价远比他想象的更加沉重。</p><p>十七岁的韩智浩在妹妹被诊断出绝症后走投无路，偶然间接触到了来自异世界的魔王。魔王承诺能够治愈妹妹，但代价是智浩必须成为他在人间的代理人，完成七项不可能的任务。</p>',
    rating: 9.3,
    views: 2100000,
    updatedAt: '2026-08-05',
    tags: ['契约', '冒险', '魔法', '兄妹'],
    chapters: 110,
    featured: false,
    isHot: true,
    isNew: false,
  },
  {
    id: 9,
    title: '初恋未满',
    slug: 'first-love-unfinished',
    author: '金素英',
    category: 'romance',
    categoryName: '恋爱',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20romance%20genre%2C%20young%20couple%20under%20cherry%20blossoms%2C%20warm%20spring%20atmosphere%2C%20soft%20pink%20and%20white%20color%20palette%2C%20clean%20sweet%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-09&orientation=portrait',
    description: '高中时期的暗恋对象在十年后重逢。当年的那份情愫从未消散，但如今的他们已经有了各自的生活。',
    descriptionHtml: '<p>高中时期的暗恋对象在十年后重逢。当年的那份情愫从未消散，但如今的他们已经有了各自的生活。</p><p>二十八岁的设计师林娜英在一次公司项目中遇到了高中时期的初恋对象韩俊浩。十年前因为毕业分离而没能说出的话，如今是否还能说出口？他们各自经历了不同的人生，却因命运的安排再次走到了一起。</p>',
    rating: 8.9,
    views: 1120000,
    updatedAt: '2026-08-04',
    tags: ['初恋', '重逢', '成长', '都市'],
    chapters: 78,
    featured: false,
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    title: '武神之路',
    slug: 'way-of-martial-god',
    author: '张泰浩',
    category: 'action',
    categoryName: '动作',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20martial%20arts%20action%20genre%2C%20powerful%20warrior%20in%20traditional%20martial%20arts%20stance%2C%20dynamic%20combat%20pose%2C%20fiery%20orange%20and%20red%20color%20scheme%2C%20clean%20intense%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-10&orientation=portrait',
    description: '在武术没落的现代，一个少年继承了古老的门派传承，走上了一条成为武神的道路。',
    descriptionHtml: '<p>在武术没落的现代，一个少年继承了古老的门派传承，走上了一条成为武神的道路。</p><p>二十一世纪的首尔，传统武术被格斗竞技所取代。高中生韩镇宇偶然间发现了家族传承数百年的武术秘籍，开始了一段艰难的修行之旅。在各大格斗赛场上，他用传统武术击败了一个又一个强大的对手。</p>',
    rating: 9.4,
    views: 1980000,
    updatedAt: '2026-08-03',
    tags: ['武术', '竞技', '热血', '成长'],
    chapters: 132,
    featured: false,
    isHot: true,
    isNew: false,
  },
  {
    id: 11,
    title: '幽灵诊所',
    slug: 'ghost-clinic',
    author: '权恩智',
    category: 'horror',
    categoryName: '恐怖',
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20horror%20medical%20genre%2C%20abandoned%20hospital%20corridor%20with%20ghostly%20figure%2C%20eerie%20greenish%20dark%20atmosphere%2C%20clean%20creepy%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-11&orientation=portrait',
    description: '一家只在午夜营业的诊所，前来就诊的"病人"都不是活人。年轻的实习生却对此一无所知。',
    descriptionHtml: '<p>一家只在午夜营业的诊所，前来就诊的"病人"都不是活人。年轻的实习生却对此一无所知。</p><p>医学院毕业生崔恩秀找到了一份看似完美的实习工作，唯一奇怪的是诊所只在午夜到凌晨四点营业。当她逐渐发现真相后，已经无法脱身。每一个深夜前来的"病人"背后，都有着一个令人心碎的故事。</p>',
    rating: 8.7,
    views: 680000,
    updatedAt: '2026-06-15',
    tags: ['恐怖', '医疗', '灵异', '悬疑'],
    chapters: 45,
    featured: false,
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: '星光咖啡馆',
    slug: 'starlight-cafe',
    author: '姜智慧',
    category: 'drama',
    categoryName: '剧情',
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20slice%20of%20life%20genre%2C%20cozy%20cafe%20interior%20with%20warm%20lighting%2C%20barista%20making%20coffee%2C%20soft%20warm%20brown%20color%20palette%2C%20clean%20heartwarming%20illustration%2C%20Korean%20digital%20art%20aesthetic&width=800&height=1100&seq=hanman-comic-12&orientation=portrait',
    description: '一家隐藏在巷子深处的小咖啡馆，每位顾客都有着属于自己的故事。在手冲咖啡的香气中，温暖治愈悄然发生。',
    descriptionHtml: '<p>一家隐藏在巷子深处的小咖啡馆，每位顾客都有着属于自己的故事。在手冲咖啡的香气中，温暖治愈悄然发生。</p><p>咖啡馆老板郑允浩是一个沉默寡言但有着温暖内心的年轻人。他坚持只做手冲咖啡，因为他相信每一杯咖啡都能让喝的人感受到制作者的心意。形形色色的顾客来到这里，分享他们的喜怒哀乐。</p>',
    rating: 9.0,
    views: 920000,
    updatedAt: '2026-08-04',
    tags: ['治愈', '日常', '咖啡', '都市'],
    chapters: 98,
    featured: false,
    isHot: false,
    isNew: true,
  },
];

export const faqItems = [
  {
    question: '韩漫画网是免费的吗？',
    answer: '是的，韩漫画网所有漫画资源均为免费在线观看。我们致力于为漫画爱好者提供优质的免费阅读体验，无需付费即可畅享海量韩漫资源。',
  },
  {
    question: '网站上的漫画更新频率如何？',
    answer: '我们每日保持同步更新，及时为您带来最新的漫画章节。热门连载作品通常会在韩国首发后24小时内完成中文版更新，确保您不会错过任何精彩内容。',
  },
  {
    question: '需要注册账号才能观看漫画吗？',
    answer: '不需要。韩漫画网支持免注册直接观看，打开网站即可开始阅读。我们简化了使用流程，让您专注于享受漫画阅读的乐趣。',
  },
  {
    question: '可以在手机上观看韩漫吗？',
    answer: '当然可以。我们的网站针对手机端进行了全面优化，无论您使用手机、平板还是电脑，都能获得流畅舒适的阅读体验。在移动设备上观看体验同样出色。',
  },
  {
    question: '韩漫画网有哪些漫画类型？',
    answer: '我们涵盖了恋爱、奇幻、动作、悬疑、喜剧、剧情、恐怖等丰富多样的漫画类型。无论您喜欢什么风格的作品，都能在韩漫画网找到心仪的内容。我们的分类系统细致清晰，帮助您快速定位喜欢的漫画。',
  },
  {
    question: '如何搜索想看的漫画？',
    answer: '您可以通过网站顶部的搜索栏直接输入漫画名称进行搜索，也可以通过分类页面按类型浏览。我们还在不断优化搜索功能，让您更快地找到想要的漫画作品。',
  },
];

export const reputations = [
  {
    name: '李明',
    role: '资深漫评人',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20professional%20portrait%20photo%20of%20a%20man%20in%20his%2030s%2C%20clean%20studio%20lighting%2C%20simple%20neutral%20background%2C%20friendly%20expression&width=120&height=120&seq=hanman-avatar-01&orientation=squarish',
    content: '韩漫画网是我见过资源最全面的韩漫平台，更新速度快、画质清晰，是漫迷的不二之选。',
    rating: 5,
  },
  {
    name: '王雪',
    role: '漫画爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20professional%20portrait%20photo%20of%20a%20woman%20in%20her%2020s%2C%20clean%20studio%20lighting%2C%20simple%20neutral%20background%2C%20warm%20smile&width=120&height=120&seq=hanman-avatar-02&orientation=squarish',
    content: '每天都会来韩漫画网追更，分类很细致，找漫画特别方便。推荐给了好多朋友！',
    rating: 5,
  },
  {
    name: '张伟',
    role: '二次元博主',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20professional%20portrait%20photo%20of%20a%20young%20man%20with%20stylish%20look%2C%20clean%20studio%20lighting%2C%20simple%20neutral%20background&width=120&height=120&seq=hanman-avatar-03&orientation=squarish',
    content: '作为漫评博主，韩漫画网的资源质量让我非常满意。推荐的作品都很优质，值得信赖。',
    rating: 5,
  },
];